import { Toggle } from '@bitcine/cinesend-theme/dist'
import { useState } from 'react'
import { Lock } from '../icons'

const IsMultiSelect = ({ field, saveField }) => {
  const [isMultiSelect, setIsMultiSelect] = useState(field.is_multi_select)
  const isLocked = field?.uneditable_when_locked_attributes?.includes('is_multi_select') ?? false
  return (
    <>
      <Toggle
        checked={isMultiSelect}
        label='Is Multi Select'
        onChange={() => {
          setIsMultiSelect(!isMultiSelect)
          saveField({ is_multi_select: !isMultiSelect })
        }}
        disabled={isLocked}
      />
      {isLocked && <Lock />}
    </>
  )
}

export default IsMultiSelect
